import { __generator } from "tslib";
import { put, select, call } from 'redux-saga/effects';
import { request } from '../../xhr';
import { normalize } from '../../redux/normalizr';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
import { withOffset } from '../../Stream';
import { getCurrentStreamId, getCurrentMediaSource, getCurrentGallection, getCurrentSubfolder, getCurrentStreamItems, } from '../selectors';
import { getGallectionTypeFromMediaSourceType } from '../helpers';
import { MediaSourceType } from '../types';
import updateGallectionSize from './updateGallectionSize';
import setGallectionCover from './setGallectionCover';
function addDeviationsHandler(action) {
    var _a, streamId, mediaSource, currentGallection, currentSubfolder, currentDeviationIds, deviations, _b, ids, entities, targetGallection;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(function (state) { return ({
                    streamId: getCurrentStreamId(state),
                    mediaSource: getCurrentMediaSource(state),
                    currentGallection: getCurrentGallection(state),
                    currentSubfolder: getCurrentSubfolder(state),
                    currentDeviationIds: getCurrentStreamItems(state),
                }); })];
            case 1:
                _a = _c.sent(), streamId = _a.streamId, mediaSource = _a.mediaSource, currentGallection = _a.currentGallection, currentSubfolder = _a.currentSubfolder, currentDeviationIds = _a.currentDeviationIds;
                deviations = action.payload.filter(function (d) { return !currentDeviationIds.includes(d.deviationId); });
                if (!streamId || deviations.length < 1) {
                    return [2 /*return*/];
                }
                _b = normalize(deviations, [deviationSchema]), ids = _b.result, entities = _b.entities;
                return [4 /*yield*/, put(withOffset.actions.insertItems({
                        streamId: streamId,
                        items: ids,
                        entities: entities,
                        offset: 0,
                    }))];
            case 2:
                _c.sent();
                // If this is a non-gallection like those used in journal galleries, we only
                // need to change the stream. Everything after this adjusts proper gallections
                if (mediaSource === MediaSourceType.CUSTOM_SET) {
                    return [2 /*return*/];
                }
                targetGallection = currentSubfolder || currentGallection;
                return [4 /*yield*/, call(updateGallectionSize, targetGallection.folderId, deviations.length)];
            case 3:
                _c.sent();
                return [4 /*yield*/, call(setGallectionCover, {
                        gallection: targetGallection,
                        deviationId: deviations[0].deviationId,
                        onlyIfMissing: true,
                    })];
            case 4:
                _c.sent();
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/copy_deviations',
                        data: {
                            type: getGallectionTypeFromMediaSourceType(mediaSource),
                            deviationids: ids,
                            target_folderid: targetGallection.folderId,
                        },
                    })];
            case 5:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
export default addDeviationsHandler;
//# sourceMappingURL=addDeviations.js.map